<template>
  <el-dialog :visible.sync="dialogFormVisible" :show-close="false" :close-on-click-modal="false" v-loading="loading">
    <el-form v-if="doEdit" label-position="left" ref="EditCurriculumChapterForm" :rules="editCurriculumChapterFormRule"
             label-width="100px" :model="editCurriculumChapterForm">
      <div style="background: #FFFFFF;text-align: center">
        <em class="el-icon-close dialog-close-manual" v-on:click="dialogFormVisible = false"></em>
        <h1 class="acr-dialog-title">修改章节信息</h1>
        <div class="acr-dialog-form">
          <el-form-item label="ID" prop="id">
            <el-input v-model="editCurriculumChapterForm.id" disabled></el-input>
          </el-form-item>
          <el-form-item label="归属课程">
            <el-input v-model="editCurriculumChapterForm.curriculumName" disabled></el-input>
          </el-form-item>
          <el-form-item label="章节名" prop="name">
            <el-input v-model="editCurriculumChapterForm.name"></el-input>
          </el-form-item>
          <el-form-item label="章节简介" prop="remark">
            <el-input type="textarea" v-model="editCurriculumChapterForm.remark"></el-input>
          </el-form-item>
          <el-button style="position: absolute;right: 0" v-on:click="doSubmitCurriculumChapter">提交</el-button>
        </div>
      </div>
    </el-form>
    <el-form v-else label-position="left" ref="AddCurriculumChapterForm" :rules="addCurriculumChapterFormRule"
             label-width="100px" :model="addCurriculumChapterForm">
      <div style="background: #FFFFFF;text-align: center">
        <em class="el-icon-close dialog-close-manual" v-on:click="dialogFormVisible = false"></em>
        <h1 class="acr-dialog-title">
          添加课程章节</h1>
        <div class="acr-dialog-form">
          <el-form-item label="归属课程" prop="curriculumId">
            <el-select v-model="addCurriculumChapterForm.curriculumId" placeholder="请选择归属课程">
              <el-option v-for="item in curriculumList" :label="item.name" :value="item.id" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="章节名" prop="name">
            <el-input v-model="addCurriculumChapterForm.name"></el-input>
          </el-form-item>
          <el-form-item label="章节简介" prop="remark">
            <el-input type="textarea" v-model="addCurriculumChapterForm.remark"></el-input>
          </el-form-item>
          <el-button style="position: absolute;right: 0" v-on:click="doSubmitCurriculumChapter">提交</el-button>
        </div>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
import AxiosBase from "@/components/axiosBase";
import {Message} from "element-ui";

export default {
  name: "EditCurriculumChapterDialog",
  data() {
    const validateId = (rule, value, callback) => {
      if (value !== this.bufferId) {
        callback(new Error("????"))
      }
      callback();
    }
    const validateRemark = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入课程简介'))
      } else {
        if (value.length < 2 || value.length > 128) {
          callback(new Error('请输入正确格式的课程简介,长度[2-128]'));
        }
        callback();
      }
    }
    return {
      loading: false,
      dialogFormVisible: false,
      doEdit: false,
      curriculumList: [],
      editCurriculumChapterForm: {
        id: '',
        curriculumName: '',
        name: '',
        remark: ''
      },
      addCurriculumChapterForm: {
        curriculumId: '',
        name: '',
        remark: ''
      },
      editCurriculumChapterFormRule: {
        id: [
          {validator: validateId, trigger: 'blur'}
        ],
        name: [
          {required: true, message: '请输入课程名', trigger: 'blur'},
          {min: 2, max: 32, message: '请输入正确长度的章节名[2-32]', trigger: 'blur'}
        ],
        remark: [
          {validator: validateRemark, trigger: 'blur'}
        ]
      },
      addCurriculumChapterFormRule: {
        curriculumId: [
          {required: true, message: '请选择归属课程', trigger: 'change'}
        ],
        name: [
          {required: true, message: '请输入课程名', trigger: 'blur'},
          {min: 2, max: 32, message: '请输入正确长度的章节名[2-32]', trigger: 'blur'}
        ],
        remark: [
          {validator: validateRemark, trigger: 'blur'}
        ]
      },
      bufferId: '',
    }
  },
  methods: {
    getCurriculumList() {
      this.loading = true;
      AxiosBase.axiosGet("/curriculum-ad/get-curriculum-list").then(response => {
        if (response !== 0) {
          this.curriculumList = response.data;
          this.loading = false;
        } else {
          Message({
            showClose: true,
            message: '无法获取课程信息',
            type: 'error'
          });
        }
      })
    },
    enterAdd() {

      this.getCurriculumList();
    },
    enterEdit() {
      this.loading = true;
      AxiosBase.axiosGet("/curriculum-ad/get-curriculum-chapter", {
        params: {
          key: this.bufferId
        }
      }).then(response => {
        if (response !== 0) {
          this.editCurriculumChapterForm = response.data[0];
          this.loading = false;
        } else {
          Message({
            showClose: true,
            message: '无法获取课程章节信息',
            type: 'error'
          });
          this.dialogFormVisible = false;
        }
      })
    },
    doSubmitCurriculumChapter() {
      if (this.doEdit) {
        this.$refs['EditCurriculumChapterForm'].validate((valid) => {
          if (valid) {
            AxiosBase.axiosPost("/curriculum-ad/edit-curriculum-chapter", this.editCurriculumChapterForm).then(response => {
              if (response !== 0) {
                this.$parent.getCurriculumChapterData();
                this.$refs['EditCurriculumChapterForm'].resetFields();
                this.dialogFormVisible = false;
                Message({
                  showClose: true,
                  message: '修改课程章节信息成功',
                  type: 'success'
                });
              }
            })
          }
        });
      } else {
        this.$refs['AddCurriculumChapterForm'].validate((valid) => {
          if (valid) {
            AxiosBase.axiosPut("/curriculum-ad/add-curriculum-chapter", this.addCurriculumChapterForm).then(response => {
              if (response !== 0) {
                this.$parent.getCurriculumChapterData();
                this.$refs['AddCurriculumChapterForm'].resetFields();
                this.dialogFormVisible = false;
                Message({
                  showClose: true,
                  message: '添加课程章节成功',
                  type: 'success'
                });
              }
            })
          }
        });
      }
    }
  }
}
</script>

